import { useState } from 'react'
import { ReferralReceivingNotice } from '@features/onboarding-kyc/ui/ReferralReceivingNotice'
import { useNavigate, useSearch } from '@tanstack/react-router'
import { DashboardScreen } from '@features/dashboard'
import type { DashboardSearch } from '@features/dashboard'
import { SaleDetailDrawer } from '@features/sales'

export function DashboardPage() {
  const search = useSearch({ from: '/protected/' })
  const navigate = useNavigate()
  const [saleScope, setSaleScope] = useState<'charge' | undefined>()
  const [saleId, setSaleId] = useState<string | null>(null)

  return (
    <>
      <DashboardScreen
        referralReceivingNotice={<ReferralReceivingNotice />}
        search={search}
        onSearchChange={(next: DashboardSearch) => {
          void navigate({ to: '/', search: next, replace: true })
        }}
        onViewSale={(id, scope) => {
          setSaleId(id)
          setSaleScope(scope)
        }}
      />
      <SaleDetailDrawer
        saleId={saleId}
        scope={saleScope}
        onClose={() => {
          setSaleId(null)
        }}
      />
    </>
  )
}
